/**
 * Build-time configuration constants.
 * These values are inlined at build time and cannot change at runtime.
 */
export const config = {
    /** Base path for the news application (e.g., "/news") */
    basePath: process.env.NEXT_PUBLIC_BASE_PATH ?? '',
    /** Build version from CI/CD pipeline */
    buildVersion: process.env.NEXT_PUBLIC_BUILD_VERSION,
} as const
